var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slider',_vm._g(_vm._b({staticClass:"rmr-slider",attrs:{"value":_vm.value,"dense":"","hide-details":""}},'v-slider',_vm.$attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }